"use strict";

import React, { Component } from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Alert extends Component {
    render () {
        const { style, options, message, close } = this.props;
        const { alertClass, alertIcon} = this.getAlertStyle(options.type);

        return (
            <div className={`alert alert-${alertClass} alert-dismissible`} style={{margin: "150px", minWidth: "1024px"}}>
                <button type="button" className="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                <h4>{alertIcon && <FontAwesomeIcon icon={alertIcon} />} {message}</h4>
            </div>
        )
    }

    getAlertStyle(type) {
        if ('success' === type) {
            return {alertClass:"success", alertIcon:"check-circle"}
        } else if ('warning' === type) {
            return {alertClass:"warning", alertIcon:"exclamation-triangle"}
        } else if ('error' === type) {
            return {alertClass:"danger", alertIcon:"ban"}
        } else if ('info' === type) {
            return {alertClass:"info", alertIcon:"info-circle"}
        } else {
            return {alertClass:"info", alertIcon:""}
        }
    }
}



export default Alert;
